import { FC } from "react";
import Steps from '../../Steps';
import classNames from "classnames";
import { ScanPageHeaderItemEnum, ScanPageHeaderStepsProps } from "../interface";

const HeaderSteps: FC<ScanPageHeaderStepsProps> = props => {
  const { stepsProps, className, style, } = props;
  const classes = classNames('scan-page-header-steps', className);
  return (
    <div className={classes} style={style}>
      {stepsProps && <Steps {...stepsProps} />}
    </div>
  );
};

HeaderSteps.displayName = ScanPageHeaderItemEnum.Steps;

export default HeaderSteps;